import '../../CommonStyles.scss';
import Chart from 'chart.js/auto';
import { CategoryScale, ChartOptions, Plugin } from 'chart.js';
import { useGetOrganizationsSummary } from 'queryHooks/analytics';
import { Bar } from 'react-chartjs-2';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
Chart.register(CategoryScale);

const endValuePlugin: Plugin<'bar'> = {
  id: 'endValuePlugin',
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((bar, index) => {
        const value = dataset.data[index] as number;
        const { x, y } = bar.getProps(['x', 'y'], true) as { x: number; y: number };
        ctx.save();
        ctx.fillStyle = '#7b7b7b';
        ctx.font = 'normal 11px sans-serif';
        ctx.textAlign = 'start';
        ctx.textBaseline = 'middle';
        ctx.fillText(String(value), x + 6, y);
        ctx.restore();
      });
    });
  },
};

export const StudentsByOrganizationChartCard = () => {
  return (
    <Paper className='analytics-card'>
      <span className='card-title'>Students by organization</span>
      <StudentsByOrganizationChart />
    </Paper>
  );
};

const StudentsByOrganizationChart = () => {
  const NUMBER_OF_ENTRIES = 10;
  const options: ChartOptions<'bar'> = {
    indexAxis: 'y' as const,
    elements: {
      bar: {
        borderWidth: 1,
        borderRadius: 4,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      y: {
        ticks: {
          font: {
            size: 11,
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };
  const { data: organizations } = useGetOrganizationsSummary();

  const sortedChartEntries = organizations?.sort((a, b) => b.studentsCount - a.studentsCount).slice(0, NUMBER_OF_ENTRIES);

  const labels = sortedChartEntries?.map((entry) => entry.name) ?? [];
  const chartDataset = {
    labels,
    datasets: [
      {
        data: sortedChartEntries?.map((entry) => entry.studentsCount) ?? [],
        backgroundColor: 'rgba(236, 105, 26, 0.7)',
        barThickness: 17,
      },
    ],
  };

  return (
    <div style={{ height: '250px' }}>
      <Bar data={chartDataset} options={options} plugins={[endValuePlugin]} />
    </div>
  );
};
